import { useState } from 'react';
import { Box, CircularProgress, IconButton, Modal, Paper, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import { ImagePaths } from '../../Utility/ImagePaths';
import { DataGrid } from '@mui/x-data-grid';
import { CommonPatientDetails } from '../../Components/Common Components/CommonComponents';
import { localGetItem } from '../../Utility/Services/CacheProviderService';
import { ContentInTooltip, AmountFormat } from '../../Components/CommonFunctions/CommonFunctions';

const labPath = new Set([
    "/MainHome", "/MainHome/TestReport", "/Results",
    "/MainHome/ForTechnicians", "/MainHome/OutsourceList",
    "/MainHome/Order/CreateOrder"])

const NotificationPopup = (props) => {
    const [state, setState] = useState({
        notifyTabIndex: "0",
        transPage: 0,
        transPageSize: 10,
    })

    const is_credit_followup = JSON.parse(localGetItem('set_due_date_for_credit_billing')) || false;

    const { FoNotifyList, isNotifyLoader, notifyPopup } = props;
    const path = window.location.pathname;

    const updateState = (newData) => {
        setState((prevState) => ({
            ...prevState,
            ...newData
        }))
    }

    const renderQMSNotify = (data) => {
        return (
            <Box width="100%" height="100%">{
                isNotifyLoader ? (
                    <Box sx={{ width: "100%", height: "calc(80vh - 8rem)", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <CircularProgress size={24} />
                    </Box>
                ) : data?.length > 0 ? data?.map((item) => {
                    let DateTime = item?.reason_type === "In Permission" ? `${item?.session_date} (${item?.from_time} - ${item?.to_time})` : `(${item?.from_date} - ${item?.to_date})`
                    return (
                        <Box key={item.id} sx={{ display: 'flex', alignItems: 'center', gap: '1vw', borderBottom: '1px solid black', padding: '1vw' }}>
                            <Box>
                                <img src={ImagePaths.NotiTick.default} alt='tick' style={{ height: '2vw', width: '2vw' }} />
                            </Box>
                            <Box>
                                <Typography fontWeight={'600'}>{item?.doctor_name ? item?.doctor_name : ''} - {item?.reason_type ? item?.reason_type : ''}</Typography>
                                <Typography fontWeight={'600'}>{item?.reason_type === "Out For Emergency" ? "" : `${DateTime}`}</Typography>
                                <Typography>{item?.reason ? item?.reason?.length > 32 ?
                                    <Tooltip placement="top" title={item.reason} arrow>
                                        <div>{item.reason?.slice(0, 30) + '...'}</div>
                                    </Tooltip> : item?.reason : ''}
                                </Typography>
                            </Box>
                        </Box>)
                }) :
                    <Box sx={{ width: "100%", height: "calc(80vh - 8rem)", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {'No Records To Be Shown'}
                    </Box>}
            </Box>)
    }

    const renderNotifyTbl = (title, data = [], coulmns = []) => {
        const rows = data?.length > 0 ? data?.map((item, index) => ({ ...item, sno: index + 1 })) : [];
        return (
            <Box width="100%" height="100%">
                {title && (
                    <>
                        <Typography fontWeight={600} fontSize="0.95vw">
                            {title}
                        </Typography>
                        <hr />
                    </>
                )}

                <Box sx={{ height: "calc(80vh - 8rem)" }}>
                    <DataGrid
                        columns={coulmns}
                        rows={rows}
                        getRowId={(row) => row['sno']}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            NoRowsOverlay: () => (
                                <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        pageSizeOptions={[10, 20, 30]}
                        pagination
                        paginationMode="client"
                        paginationModel={{
                            page: state.transPage,
                            pageSize: state.transPageSize
                        }}
                        onPaginationModelChange={(model) => {
                            updateState({
                                transPage: model.page,
                                transPageSize: model.pageSize
                            })
                        }}
                        headerHeight={40}
                        disableRowSelectionOnClick
                        loading={isNotifyLoader}
                    />
                </Box>
            </Box>
        )
    }

    const renderCreditFollowUp = (title = "", data = []) => {

        const columns = [
            {
                field: "patient_details",
                headerName: "Patient Details",
                flex: 0.30,
                renderCell: ({ row }) => <CommonPatientDetails data={row} />,
            },
            {
                field: "patient_type",
                headerName: "Patient Type",
                flex: 0.10,
                renderCell: ({ row }) => (<Typography fontSize="0.90vw"> {row.patient_type || "-"}</Typography>),
            },
            {
                field: "bill_amount",
                headerName: "Bill Amount",
                flex: 0.20, headerAlign: "center", align: "center",
                renderCell: ({ row }) => (<Typography fontSize="0.90vw">{AmountFormat(row?.bill_amount)}</Typography>)
            },
            {
                field: "due_date",
                headerName: "Follow-Up Date",
                flex: 0.20, headerAlign: "center", align: "center",
                renderCell: ({ row }) => (<Typography fontSize="0.90vw">{row?.due_date || "-"}</Typography>)
            },
            {
                field: "pending_amount",
                headerName: "Pending Amount",
                flex: 0.20, headerAlign: "center", align: "center",
                renderCell: ({ row }) => (<Typography fontSize="0.90vw"> {AmountFormat(row.pending_amount)} </Typography>),
            },
        ];
        return (renderNotifyTbl(title, data, columns))
    }

    const renderOutsourceNotifyTbl = (title = "", data) => {
        const rows = data?.length > 0 ? data?.map((item, index) => ({ ...item, sno: index + 1 })) : [];
        const columns = [
            {
                field: "patient_details",
                headerName: "Patient Details",
                flex: 0.35,
                renderCell: ({ row }) => <CommonPatientDetails data={row} />,
            },
            {
                field: "patient_type",
                headerName: "Patient Type",
                flex: 0.20,
                renderCell: ({ row }) => (<Typography fontSize="0.90vw"> {row.patient_type || "-"}</Typography>),
            },
            {
                field: "lab_transit",
                headerName: "Lab Transit Details",
                flex: 0.25,
                renderCell: ({ row }) => (
                    <Box display="flex" flexDirection="column">
                        {ContentInTooltip(row?.outsource_lab || "-", 25, "0.80vw", 50)}
                        {ContentInTooltip(row?.outsourse_contact_person || "-", 25, "0.80vw", 50)}
                        {ContentInTooltip(row?.contact_person_mobile_no || "-", 25, "0.80vw", 50)}
                    </Box>
                ),
            },
            {
                field: "outsource_due_date",
                headerName: "Outsource Due Date",
                flex: 0.20, headerAlign: "center", align: "center",
                renderCell: ({ row }) => (<Typography fontSize="0.90vw"> {row.outsource_due_date || "-"} </Typography>),
            },
        ];
        return (renderNotifyTbl(title, rows, columns))
    }

    return (
        <Modal open={notifyPopup} onClose={props.onClose}>
            <Paper sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                outline: "none",
                height: "80vh", width: "55vw", padding: '0.5vw', overflow: 'hidden'
            }}>
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography fontWeight={'600'}>Notification</Typography>
                    <IconButton onClick={props.onClose} size="small" >
                        <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} />
                    </IconButton>
                </Box>
                <hr />
                <Box sx={{ height: "calc(80vh - 4rem)", padding: "0.5vw" }}>
                    {
                        (
                            labPath?.has(path) ?
                                (<Box>
                                    <Tabs value={state.notifyTabIndex} onChange={(event, newValue) => {
                                        updateState({ notifyTabIndex: newValue });
                                    }}>
                                        <Tab value="0" label="Outsource Due" className='eMed_tab_header' />
                                        {is_credit_followup && <Tab value="1" label="Credit Follow Up" className='eMed_tab_header' />}
                                    </Tabs>
                                    {
                                        state.notifyTabIndex === "0" ?
                                            renderOutsourceNotifyTbl("", FoNotifyList?.outsource_test_due || [])
                                            : renderCreditFollowUp("", FoNotifyList?.credit_due || [])
                                    }
                                </Box>)
                                : path === "/OPHome" ? (<Box>
                                    <Tabs value={state.notifyTabIndex} onChange={(event, newValue) => {
                                        updateState({ notifyTabIndex: newValue });
                                    }}>
                                        <Tab value="0" label="QMS Notification" className='eMed_tab_header' />
                                        {is_credit_followup && <Tab value="1" label="Credit Follow Up" className='eMed_tab_header' />}
                                    </Tabs>
                                    {
                                        state.notifyTabIndex === "0" ?
                                            renderQMSNotify(FoNotifyList?.doctor_info || [])
                                            : renderCreditFollowUp("", FoNotifyList?.credit_due || [])
                                    }
                                </Box>)
                                    : (renderCreditFollowUp("Credit Follow Up", window.location.pathname === "/IPHome" ? FoNotifyList?.credit_due || [] : FoNotifyList || []))
                        )
                    }
                </Box>
            </Paper>
        </Modal>
    )
}

export default NotificationPopup